/* tslint:disable */
/* eslint-disable */
/**
 * B2B Auth
 * Authentication API  # Tracking Metrics * `b2bportal.auth.session.create.failure`   * tags: `api_version`, `auth_method`, `error_code`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.create.success`   * tags: `api_version`, `auth_method`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.info.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.info.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.refresh.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.refresh.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.remove.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.remove.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.verify.failure`   * tags: `error_code`, `tenantid` * `b2bportal.auth.session.verify.latency`   * tags: `tenantid` * `b2bportal.auth.session.verify.success`   * tags: `tenantid` * `b2bportal.auth.user.finalized.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.finalized.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.user.info.update.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.info.update.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.resend.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.resend.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.send.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.send.success`   * tags: `api_version`, `tenantid`   # Tracking Error Codes * `already_finalized` * `authentication_method_not_implemented` * `bad_request` * `booking_scope_required` * `cannot_finalize_guest` * `deleted_user` * `email_taken` * `existing_session_token` * `existing_session` * `expired_code` * `expired_token` * `ineligible` * `internal_error` * `invalid_code` * `invalid_email` * `invalid_hash` * `invalid_id` * `invalid_phone_number` * `invalid_token` * `malformed_session` * `merged_user` * `no_session_token` * `not_verified` * `phone_number_taken` * `price_watch_scope_required` * `rejected_session` * `request_deserialization_error` * `response_serialization_error` * `send_failed` * `server_error` * `too_many_user_for_device` * `unauthorized` * `unknown` * `user_does_not_exist` * `user_not_found`  
 *
 * The version of the OpenAPI document: v0p40
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from "./configuration";
import type { RequestArgs } from "./base";
import type { AxiosInstance, AxiosResponse } from 'axios';
import { RequiredError } from "./base";

/**
 *
 * @export
 */
export const DUMMY_BASE_URL = 'https://example.com'

/**
 *
 * @throws {RequiredError}
 * @export
 */
export const assertParamExists = function (functionName: string, paramName: string, paramValue: unknown) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
}

/**
 *
 * @export
 */
export const setApiKeyToObject = async function (object: any, keyParamName: string, configuration?: Configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === 'function'
            ? await configuration.apiKey(keyParamName)
            : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
}

/**
 *
 * @export
 */
export const setBasicAuthToObject = function (object: any, configuration?: Configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = { username: configuration.username, password: configuration.password };
    }
}

/**
 *
 * @export
 */
export const setBearerAuthToObject = async function (object: any, configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
}

/**
 *
 * @export
 */
export const setOAuthToObject = async function (object: any, name: string, scopes: string[], configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken(name, scopes)
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
}

function setFlattenedQueryParams(urlSearchParams: URLSearchParams, parameter: any, key: string = ""): void {
    if (parameter == null) return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            (parameter as any[]).forEach(item => setFlattenedQueryParams(urlSearchParams, item, key));
        } 
        else {
            Object.keys(parameter).forEach(currentKey => 
                setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== '' ? '.' : ''}${currentKey}`)
            );
        }
    } 
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        } 
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}

/**
 *
 * @export
 */
export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
}

/**
 *
 * @export
 */
export const serializeDataIfNeeded = function (value: any, requestOptions: any, configuration?: Configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
}

/**
 *
 * @export
 */
export const toPathString = function (url: URL) {
    return url.pathname + url.search + url.hash
}

/**
 *
 * @export
 */
export const createRequestFunction = function (axiosArgs: RequestArgs, globalAxios: AxiosInstance, BASE_PATH: string, configuration?: Configuration) {
    return <T = unknown, R = AxiosResponse<T>>(axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (axios.defaults.baseURL ? '' : configuration?.basePath ?? basePath) + axiosArgs.url};
        return axios.request<T, R>(axiosRequestArgs);
    };
}
